import React from "react";
import AdminCrud from "./AdminCrud";

export default function AdminPromotions() {
    return (
        <AdminCrud title="Promoții" endpoint="/admin/promotions" idField="promotion_id" testPrefix="promotions"
                   columns={[
                       { key: "banner_image", label: "Img", type: "image" },
                       { key: "title", label: "Titlu" },
                       { key: "applies_to", label: "Tip" },
                       { key: "auto_discount_code", label: "Cod auto" },
                       { key: "active", label: "Activ", type: "boolean" },
                   ]}
                   fields={[
                       { key: "title", label: "Titlu", required: true },
                       { key: "description", label: "Descriere", type: "textarea", colSpan: 2 },
                       { key: "banner_image", label: "Banner imagine", type: "image", colSpan: 2 },
                       { key: "applies_to", label: "Tip", type: "select", options: ["all", "product", "category"] },
                       { key: "target_ids", label: "ID-uri țintă", type: "tags", colSpan: 2 },
                       { key: "auto_discount_code", label: "Cod reducere automat" },
                       { key: "active", label: "Activ", type: "boolean" },
                       { key: "start_date", label: "Start (ISO)" },
                       { key: "end_date", label: "End (ISO)" },
                   ]}
                   defaultItem={{ applies_to: "all", active: true, target_ids: [] }} />
    );
}
